export enum folderColors {
  'INDEX' = '#eadbff',
  'Damages' = '#ffc1c1',
  'Client Upload' = '#ccff00',
  'Discovery' = '#ffda81',
  'Liability' = '#d1f3c3',
  'Other' = '#e7e7e7',
  'custom' = '#c5f0f6'
}
